import Stack from '@mui/material/Stack/Stack';
import React from 'react';
import Typography from '@mui/material/Typography';
import { Order, requiresAttention } from '../../../../Models';
import { usePrescriptionData } from '../../../../services/api/queries/usePrescriptionData';
import { capitalizeEachWord } from '../../../../utils/utils';

type PrescriptionsSummaryProps = {
    order: Order;
};

export function PrescriptionsSummary({ order }: PrescriptionsSummaryProps) {
    const { otcProducts, electronicProducts, files } = usePrescriptionData(order);

    // Combine both product types and add a unique identifier
    let allProducts = [
        ...electronicProducts.map((product, index) => ({
            id: `electronic-${index}`,
            name: capitalizeEachWord(product.name),
            quantity: product.quantity,
        })),
        ...otcProducts.map((product, index) => ({
            id: `otc-${index}`,
            name: capitalizeEachWord(product.name),
            quantity: undefined,
        })),
    ];
    if (order.user_offer && order.user_offer.products) {
        allProducts = order.user_offer.products;
    }
    // Limit to 3 products
    const hasMoreProducts = allProducts.length > 3;
    const productsToShow = allProducts.slice(0, 3);

    const attentionNeeded = requiresAttention(order);
    return (
        <Stack direction="column" alignItems="flex-start" spacing={0.5} width="100%">
            {productsToShow.map((product) => (
                <Typography
                    key={product.id}
                    variant="body2"
                    sx={{
                        width: '100%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: attentionNeeded ? 'white' : 'black',
                    }}>
                    {product.quantity ? ` x${product.quantity} ` : ''}
                    {product.name}
                </Typography>
            ))}
            {hasMoreProducts && (
                <Typography variant="body2" sx={{ color: attentionNeeded ? 'white' : 'black' }}>
                    ...
                </Typography>
            )}
            {!!files.length && (
                <Typography
                    variant="body2"
                    sx={{
                        width: '100%',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: attentionNeeded ? 'white' : 'black',
                    }}>
                    Archivos adjuntos ({files.length})
                </Typography>
            )}
        </Stack>
    );
}
